<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* =============================================================================
   FATURA BİLGİLERİ POPUP (Bireysel TCKN / Kurumsal VKN) – ÖZEL GELİŞTİRME
   -----------------------------------------------------------------------------
   v2 29.10.2026 : Sepet sayfası + sağ çekmece doğrulaması
   v3 30.10.2026 : Fatura bilgisi zorunlu değil yapıldı (Sirac talebi)
   v4 30.10.2026 : "Fatura bilgisi eklemek istiyorum" kutucuğu işaretlenince popup
                   açılır (masaüstü ortada, mobil alttan panel). Kaydet ile doğrulanır
                   ve cart attributes olarak kaydedilir. ÖDEME BUTONLARINA ARTIK HİÇ
                   MÜDAHALE EDİLMEZ (önceki sürümdeki takılma şikayeti üzerine).
   Yapan  : Encode Digital Solutions – Sirac (Claude AI ile) | info@encode.com.tr
   Bağlı  : snippets/fatura-bilgileri.liquid (kutucuk/özet), assets/custom.css (stil),
            sections/main-cart.liquid ve snippets/halo-side-cart.liquid (render satırları).
            Tema ayarları > Custom JS ve Custom CSS AÇIK olmalı.
   Uyumluluk: ES5 (eski Safari/Android tarayıcılar), :has() kullanılmaz, iOS kaydırma
            kilidi, ESC/arka plan ile kapanma, klavye odak döngüsü.
   Not    : Tema güncellemesinde bu dosya sıfırlanabilir; bu blok yeniden eklenmeli.
   ============================================================================= */
(function () {
  if (window.__ulFatura4) return;
  window.__ulFatura4 = true;
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  function isTCKN(v) {
    if (!/^[1-9][0-9]{10}$/.test(v)) return false;
    var d = v.split('').map(Number), odd = d[0] + d[2] + d[4] + d[6] + d[8], even = d[1] + d[3] + d[5] + d[7];
    var d10 = ((odd * 7 - even) % 10 + 10) % 10, s = 0;
    for (var i = 0; i < 10; i++) s += d[i];
    return d10 === d[9] && s % 10 === d[10];
  }
  function isVKN(v) {
    if (!/^[0-9]{10}$/.test(v)) return false;
    var sum = 0;
    for (var i = 0; i < 9; i++) {
      var t = (Number(v.charAt(i)) + 9 - i) % 10, p = (t * Math.pow(2, 9 - i)) % 9;
      if (t !== 0 && p === 0) p = 9;
      sum += p;
    }
    return (10 - (sum % 10)) % 10 === Number(v.charAt(9));
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Kayıtlı veri (sayfa ilk yüklendiğinde snippet'teki data-* alanlarından okunur)
  var data = { tipi: '', tc: '', firma: '', vd: '', vkn: '' };
  function readFromDom() {
    var r = document.querySelector('.ul-fatura');
    if (!r) return;
    data = { tipi: r.getAttribute('data-tipi') || '', tc: r.getAttribute('data-tc') || '', firma: r.getAttribute('data-firma') || '',
             vd: r.getAttribute('data-vd') || '', vkn: r.getAttribute('data-vkn') || '' };
  }
  function hasData() { return (data.tipi === 'Bireysel' && data.tc) || (data.tipi === 'Kurumsal' && data.vkn); }
  function summaryText() {
    if (data.tipi === 'Bireysel') return 'Bireysel · T.C. •••••••' + data.tc.slice(-4);
    return 'Kurumsal · ' + data.firma;
  }
  // Sayfadaki tüm kutuları (sepet sayfası + çekmece) güncelle
  function paint() {
    var on = !!hasData();
    each(document.querySelectorAll('.ul-fatura'), function (r) {
      r.className = 'ul-fatura' + (on ? ' is-saved' : '');
      var cb = r.querySelector('[data-ul-cb]'); if (cb) cb.checked = on;
      var s = r.querySelector('[data-ul-summary]'); if (s) s.textContent = on ? summaryText() : '';
      r.setAttribute('data-tipi', data.tipi); r.setAttribute('data-tc', data.tc); r.setAttribute('data-firma', data.firma);
      r.setAttribute('data-vd', data.vd); r.setAttribute('data-vkn', data.vkn);
    });
  }
  function save(d) {
    return fetch(ROOT_URL + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Fatura Tipi': d.tipi, 'TC Kimlik No': d.tc, 'Firma Unvani': d.firma, 'Vergi Dairesi': d.vd, 'Vergi Kimlik No': d.vkn } })
    }).then(function (r) { if (!r.ok) throw new Error('save'); return r; });
  }

  // ---------- Popup ----------
  var modal, panel, lastFocus, scrollY = 0;
  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'ul-fm';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="ul-fm__backdrop" data-ul-close></div>' +
      '<div class="ul-fm__panel" role="dialog" aria-modal="true" aria-labelledby="ul-fm-title">' +
        '<div class="ul-fm__grip" aria-hidden="true"></div>' +
        '<div class="ul-fm__head"><h2 id="ul-fm-title" class="ul-fm__title">Fatura bilgileri</h2>' +
          '<button type="button" class="ul-fm__x" data-ul-close aria-label="Kapat">&times;</button></div>' +
        '<div class="ul-fm__toggle" role="radiogroup" aria-label="Fatura tipi">' +
          '<button type="button" role="radio" class="ul-fm__tab" data-ul-tab="Bireysel">Bireysel</button>' +
          '<button type="button" role="radio" class="ul-fm__tab" data-ul-tab="Kurumsal">Kurumsal</button></div>' +
        '<div class="ul-fm__body">' +
          '<div class="ul-fm__group ul-fm__g-b">' +
            '<label class="ul-fm__label" for="ul-fm-tc">T.C. Kimlik No</label>' +
            '<input class="ul-fm__input" id="ul-fm-tc" data-k="tc" inputmode="numeric" maxlength="11" autocomplete="off" placeholder="11 haneli T.C. kimlik numaranız">' +
            '<div class="ul-fm__err" data-err="tc">Geçerli bir T.C. kimlik numarası giriniz.</div></div>' +
          '<div class="ul-fm__group ul-fm__g-k">' +
            '<label class="ul-fm__label" for="ul-fm-firma">Firma ünvanı</label>' +
            '<input class="ul-fm__input" id="ul-fm-firma" data-k="firma" autocomplete="organization" placeholder="Fatura kesilecek firma ünvanı">' +
            '<div class="ul-fm__err" data-err="firma">Firma ünvanı giriniz.</div>' +
            '<div class="ul-fm__row">' +
              '<div><label class="ul-fm__label" for="ul-fm-vd">Vergi dairesi</label>' +
              '<input class="ul-fm__input" id="ul-fm-vd" data-k="vd" autocomplete="off" placeholder="Örn. Beşiktaş">' +
              '<div class="ul-fm__err" data-err="vd">Vergi dairesi giriniz.</div></div>' +
              '<div><label class="ul-fm__label" for="ul-fm-vkn">Vergi kimlik no</label>' +
              '<input class="ul-fm__input" id="ul-fm-vkn" data-k="vkn" inputmode="numeric" maxlength="11" autocomplete="off" placeholder="10 haneli vergi numarası">' +
              '<div class="ul-fm__err" data-err="vkn">Geçerli bir vergi numarası giriniz.</div></div>' +
            '</div></div>' +
          '<div class="ul-fm__err ul-fm__err--save" data-err="save">Bilgiler kaydedilemedi, lütfen tekrar deneyin.</div>' +
        '</div>' +
        '<div class="ul-fm__actions">' +
          '<button type="button" class="ul-fm__btn ul-fm__btn--ghost" data-ul-close>Vazgeç</button>' +
          '<button type="button" class="ul-fm__btn ul-fm__btn--primary" data-ul-save>Kaydet</button></div>' +
      '</div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.ul-fm__panel');

    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-ul-close]')) { e.preventDefault(); close(false); return; }
      var tab = t.closest('[data-ul-tab]'); if (tab) { setTab(tab.getAttribute('data-ul-tab')); return; }
      if (t.closest('[data-ul-save]')) { e.preventDefault(); submit(); }
    });
    modal.addEventListener('input', function (e) {
      var el = e.target, k = el.getAttribute('data-k');
      if (k === 'tc' || k === 'vkn') { var v = el.value.replace(/\D/g, ''); if (v !== el.value) el.value = v; }
      if (k) showErr(k, false);
    });
    modal.addEventListener('keydown', function (e) {
      var key = e.key || e.keyCode;
      if (key === 'Escape' || key === 'Esc' || key === 27) { e.preventDefault(); close(false); return; }
      if (key === 'Enter' || key === 13) { if (e.target.tagName === 'INPUT') { e.preventDefault(); submit(); } return; }
      if (key === 'Tab' || key === 9) {
        var f = Array.prototype.filter.call(panel.querySelectorAll('button, input'), function (x) { return x.offsetParent !== null && !x.disabled; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
  function field(k) { return modal.querySelector('[data-k="' + k + '"]'); }
  function showErr(k, on) {
    var e = modal.querySelector('[data-err="' + k + '"]'); if (e) e.className = 'ul-fm__err' + (k === 'save' ? ' ul-fm__err--save' : '') + (on ? ' is-on' : '');
    var f = k !== 'save' && field(k); if (f) { f.className = 'ul-fm__input' + (on ? ' is-bad' : ''); f.setAttribute('aria-invalid', on ? 'true' : 'false'); }
  }
  function setTab(t) {
    modal.setAttribute('data-tab', t);
    each(modal.querySelectorAll('[data-ul-tab]'), function (b) {
      var on = b.getAttribute('data-ul-tab') === t;
      b.className = 'ul-fm__tab' + (on ? ' is-on' : ''); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    ['tc', 'firma', 'vd', 'vkn', 'save'].forEach(function (k) { showErr(k, false); });
  }
  function lockScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('ul-fm-lock');
    document.body.style.top = (-scrollY) + 'px';
  }
  function unlockScroll() {
    document.documentElement.classList.remove('ul-fm-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }
  function open() {
    buildModal(); readFromDom();
    field('tc').value = data.tc; field('firma').value = data.firma; field('vd').value = data.vd; field('vkn').value = data.vkn;
    setTab(data.tipi === 'Kurumsal' ? 'Kurumsal' : 'Bireysel');
    lastFocus = document.activeElement;
    modal.removeAttribute('hidden');
    lockScroll();
    // animasyon için bir sonraki karede sınıf ekle
    window.requestAnimationFrame(function () { modal.className = 'ul-fm is-open'; });
    setTimeout(function () { var f = modal.getAttribute('data-tab') === 'Kurumsal' ? field('firma') : field('tc'); try { f.focus({ preventScroll: true }); } catch (x) { f.focus(); } }, 60);
  }
  function close(saved) {
    if (!modal || modal.hasAttribute('hidden')) return;
    modal.className = 'ul-fm';
    modal.setAttribute('hidden', '');
    unlockScroll();
    if (!saved) paint(); // vazgeçildiyse kutucuk kayıtlı duruma geri döner
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (x) {} }
  }
  function submit() {
    var t = modal.getAttribute('data-tab'), ok = true, d;
    var v = function (k) { return field(k).value.replace(/^\s+|\s+$/g, ''); };
    if (t === 'Bireysel') {
      if (!isTCKN(v('tc'))) { showErr('tc', true); ok = false; }
      d = { tipi: 'Bireysel', tc: v('tc'), firma: '', vd: '', vkn: '' };
    } else {
      if (v('firma').length < 2) { showErr('firma', true); ok = false; }
      if (v('vd').length < 2) { showErr('vd', true); ok = false; }
      if (!(isVKN(v('vkn')) || isTCKN(v('vkn')))) { showErr('vkn', true); ok = false; }
      d = { tipi: 'Kurumsal', tc: '', firma: v('firma'), vd: v('vd'), vkn: v('vkn') };
    }
    if (!ok) { var bad = modal.querySelector('.is-bad'); if (bad) bad.focus(); return; }
    var btn = modal.querySelector('[data-ul-save]'); btn.disabled = true; btn.textContent = 'Kaydediliyor...';
    save(d).then(function () { data = d; paint(); close(true); })
      .catch(function () { showErr('save', true); })
      .then(function () { btn.disabled = false; btn.textContent = 'Kaydet'; });
  }
  function clearData() {
    data = { tipi: '', tc: '', firma: '', vd: '', vkn: '' }; paint();
    save(data).catch(function () {});
  }

  // ---------- Olaylar (sepet sayfası + AJAX ile yüklenen çekmece) ----------
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.hasAttribute || !cb.hasAttribute('data-ul-cb')) return;
    readFromDom();
    if (cb.checked) open(); // vazgeçilirse close() kutucuğu eski haline döndürür
    else clearData();
  });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-ul-edit]');
    if (b) { e.preventDefault(); readFromDom(); open(); }
  });
  // Geri tuşuyla (bfcache) dönülünce sayfa donuk kalmasın
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (modal) close(true);
    if (!document.getElementById('cart_conditions') && !document.getElementById('sidebar_cart_conditions')) {
      each(document.querySelectorAll('#cart-checkout[disabled], #cart-sidebar-checkout[disabled]'), function (b) { b.disabled = false; });
    }
  });
})();
